import PropTypes from 'prop-types';



// ------ shapes
const SHAPE_TREE_SELECT_ITEM_SINGLE = {
    content: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
        PropTypes.string
    ]).isRequired,
    isSelectable: PropTypes.bool,
    searchPredicate: PropTypes.func,
    value: PropTypes.any
};


export const SHAPE_TREE_SELECT_ITEM = {
    ...SHAPE_TREE_SELECT_ITEM_SINGLE,
    children: PropTypes.arrayOf(PropTypes.shape(SHAPE_TREE_SELECT_ITEM_SINGLE))
};


export const SHAPE_TREE_SELECT = {
    onChange: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape(SHAPE_TREE_SELECT_ITEM)).isRequired,
    values: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.string),
        PropTypes.string
    ])
};
